import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { stripFrontMatter } from "../../../utils/markdownHelpers";
import kycFormIntegrationFile from "../../../assets/markDownFiles/id/form_integration.md";

// The ACT ID Form Integration Guide. It is plain GitHub-flavoured markdown, so
// it only has its front matter removed; convertMdxToMd is not used because it
// strips `{...}` (e.g. `{verificationId}` in the API paths) outside code blocks.
const KycFormIntegration = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (
      typeof kycFormIntegrationFile === "string" &&
      kycFormIntegrationFile.startsWith("/static")
    ) {
      fetch(kycFormIntegrationFile)
        .then((res) => res.text())
        .then((raw) => setContent(stripFrontMatter(raw)));
    } else {
      setContent(stripFrontMatter(kycFormIntegrationFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT ID (KYC)
      </Typography>
      {content ? (
        <MarkdownRenderer content={content} />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default KycFormIntegration;
